/* Product description rectangles only. Native details remain usable without JS. */
(() => {
  if (window.swProductDescriptionMotion) return;
  window.swProductDescriptionMotion = true;
  const selector = '.sw-wave1-description details.sw-wave1-detail';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Map();
  function settle(item, state) {
    if (active.get(item) !== state) return;
    active.delete(item);
    state.animation.onfinish = null;
    state.animation.cancel();
    item.open = state.open;
    item.style.height = state.height;
    item.style.overflow = state.overflow;
  }
  function finishAll() { active.forEach((state, item) => settle(item, state)); }
  document.addEventListener('click', event => {
    const summary = event.target.closest && event.target.closest('summary');
    if (!summary || !summary.parentElement.matches(selector)) return;
    const item = summary.parentElement;
    if (summary !== item.querySelector(':scope > summary') ||
        !item.querySelector(':scope > .sw-wave1-body')) return;
    if (event.target.closest('a, button, input, select, textarea')) return;
    if (reduced.matches || typeof item.animate !== 'function') return;
    event.preventDefault();
    const previous = active.get(item);
    const open = previous ? !previous.open : !item.open;
    const start = item.getBoundingClientRect().height;
    const height = previous ? previous.height : item.style.height;
    const overflow = previous ? previous.overflow : item.style.overflow;
    if (previous) {
      previous.animation.onfinish = null;
      previous.animation.cancel();
      active.delete(item);
    }
    item.style.height = height;
    item.open = false;
    const closedHeight = item.getBoundingClientRect().height;
    item.open = true;
    const end = open ? item.getBoundingClientRect().height : closedHeight;
    item.style.overflow = 'hidden';
    try {
      const animation = item.animate(
        [{ height: start + 'px' }, { height: end + 'px' }],
        { duration: 300, easing: 'ease' }
      );
      const state = { animation, open, height, overflow };
      active.set(item, state);
      animation.onfinish = () => settle(item, state);
    } catch (_) {
      item.open = open;
      item.style.height = height;
      item.style.overflow = overflow;
    }
  });
  window.addEventListener('resize', finishAll, { passive: true });
  window.addEventListener('pagehide', finishAll);
  document.addEventListener('shopify:section:unload', finishAll);
  if (reduced.addEventListener) reduced.addEventListener('change', finishAll);
})();
